// Registers all app-specific help markdown files with the appfw help system.
import {initHelpTexts} from "../../appfw/help-texts.ts";

const modules = import.meta.glob<string>('./*/*.md', {
    query: '?raw',
    import: 'default',
    eager: true,
});

initHelpTexts(modules);
